import React from "react";
const Loader = () => {
  return (
    <>
    <div
        style={{
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: '9999'
        }}
        className="custom-overlay"
      />

      <div style={{ position: 'fixed', zIndex: '10000' }}>
        <div className="screen-loader vertical">
          <div className="loaderWrapper"></div>
          <div className="loader-text">processing..</div>
        </div>
      </div>
    </>
  );
};
export default Loader;